var _style, _g, _rect, _path, _polygon, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "photo_placeholder",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505.5 449.9",
    style: {
      enableBackground: "new 0 0 505.5 449.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:#1D1D1B;}\n\t\t.st1{fill:#FFFFFF;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.8,450.2H54.9L30,406.4v43.8H13v-70.4h17l24.9,43.8v-43.8h16.9V450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.1,416.5c0,6.9-1.3,12.9-3.8,18.2c-2.5,5.3-6.2,9.4-10.9,12.2c-4.7,2.9-10,4.3-16,4.3s-11.3-1.4-16-4.1 c-4.6-2.8-8.3-6.7-10.9-11.8c-2.6-5.1-4-11-4.1-17.6v-4c0-6.9,1.3-13,3.8-18.2c2.5-5.3,6.2-9.3,10.9-12.2 c4.7-2.9,10.1-4.3,16.1-4.3c6,0,11.3,1.4,16,4.3c4.7,2.8,8.3,6.9,10.9,12.1c2.6,5.2,3.9,11.2,3.9,18V416.5z M124.9,413.6 c0-7-1.2-12.3-3.5-15.9c-2.3-3.6-5.7-5.4-10-5.4c-8.5,0-13,6.4-13.5,19.1l0,5.2c0,6.9,1.1,12.2,3.4,15.9c2.3,3.7,5.7,5.6,10.2,5.6 c4.3,0,7.6-1.8,9.9-5.5s3.5-8.9,3.5-15.7V413.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.5,426.4v23.9h-17v-70.4h28.1c5.4,0,10.1,1,14.3,3c4.1,2,7.3,4.8,9.6,8.5c2.3,3.7,3.4,7.8,3.4,12.4 c0,6.9-2.5,12.4-7.4,16.5c-4.9,4.1-11.7,6.2-20.2,6.2H192.5z M192.5,413.3h11.1c3.3,0,5.8-0.8,7.5-2.5c1.7-1.6,2.6-4,2.6-7 c0-3.3-0.9-5.9-2.7-7.9c-1.8-2-4.2-3-7.3-3h-11.3V413.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.8,450.2h-16.9v-29.4h-25v29.4h-17v-70.4h17v27.9h25v-27.9h16.9V450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.1,416.5c0,6.9-1.3,12.9-3.8,18.2c-2.5,5.3-6.2,9.4-10.9,12.2c-4.7,2.9-10,4.3-16,4.3s-11.3-1.4-16-4.1 c-4.6-2.8-8.3-6.7-10.9-11.8c-2.6-5.1-4-11-4.1-17.6v-4c0-6.9,1.3-13,3.8-18.2c2.5-5.3,6.2-9.3,10.9-12.2 c4.7-2.9,10.1-4.3,16.1-4.3c6,0,11.3,1.4,16,4.3c4.7,2.8,8.3,6.9,10.9,12.1c2.6,5.2,3.9,11.2,3.9,18V416.5z M351.9,413.6 c0-7-1.2-12.3-3.5-15.9c-2.3-3.6-5.7-5.4-10-5.4c-8.5,0-13,6.4-13.5,19.1l0,5.2c0,6.9,1.1,12.2,3.4,15.9c2.3,3.7,5.7,5.6,10.2,5.6 c4.3,0,7.6-1.8,9.9-5.5s3.5-8.9,3.5-15.7V413.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429,393h-21.1v57.3h-17V393h-20.7v-13.1H429V393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.4,416.5c0,6.9-1.3,12.9-3.8,18.2c-2.5,5.3-6.2,9.4-10.9,12.2c-4.7,2.9-10,4.3-16,4.3s-11.3-1.4-16-4.1 c-4.6-2.8-8.3-6.7-10.9-11.8c-2.6-5.1-4-11-4.1-17.6v-4c0-6.9,1.3-13,3.8-18.2c2.5-5.3,6.2-9.3,10.9-12.2 c4.7-2.9,10.1-4.3,16.1-4.3c6,0,11.3,1.4,16,4.3c4.7,2.8,8.3,6.9,10.9,12.1c2.6,5.2,3.9,11.2,3.9,18V416.5z M477.2,413.6 c0-7-1.2-12.3-3.5-15.9c-2.3-3.6-5.7-5.4-10-5.4c-8.5,0-13,6.4-13.5,19.1l0,5.2c0,6.9,1.1,12.2,3.4,15.9c2.3,3.7,5.7,5.6,10.2,5.6 c4.3,0,7.6-1.8,9.9-5.5s3.5-8.9,3.5-15.7V413.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    className: "st1",
    width: 472.5,
    height: 313.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.5,33v280.2H33V33H472.5 M505.5,0H0v346.2h505.5V0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "347.2,121.8 276.7,185 183,91.9 88.8,185.4 88.8,268.1 418.2,268.1 418.2,185.4 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 288.6,
    cy: 104.9,
    r: 23.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 488.6,
    style: {
      fill: "none"
    },
    width: 497.4,
    height: 74.9
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photo_placeholder.07873d84b0ab923df3083241d0ecb46a.svg";
export { ForwardRef as ReactComponent };